import { TabsDef } from '../utils/TabsDef';
import { Views } from '../constants';
import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';

export const useTabs = () => {
  const store = useCreativeTemplatesBuilderStore();

  const activeTab = store.activeTab;

  const selections = {
    [Views.CarouselCreativeTemplateEditor]: store.carouselSelections,
    [Views.ImageOrVideoCreativeTemplateEditor]: store.imageOrVideoCreativeTemplateInputs
  };

  const DEFAULT_SELECTIONS_VIEW = Views.ImageOrVideoCreativeTemplateEditor;
  const activeView = store.view === Views.CreativesGenerator ? DEFAULT_SELECTIONS_VIEW : store.view;

  const handleTabChange = (newTabKey: string): void => {
    const existTab = TabsDef.find(({ key }) => key === newTabKey);

    if (!existTab) {
      throw new Error('Incorrect Tab');
    }

    store.setActiveTab(existTab);
  };

  return { handleTabChange, activeTab, selections: selections[activeView], activeView };
};
